var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 231.976,
    height: 231.972,
    viewBox: "0 0 231.976 231.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop-28",
    transform: "translate(-3.001 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M233.21,52.224a7.752,7.752,0,0,0-5.977-2.83H56.9L49.256,9.279A7.723,7.723,0,0,0,41.663,3H10.733a7.732,7.732,0,1,0,0,15.465H35.261L60.832,152.692a34.675,34.675,0,0,0,34.023,28.154H182A34.728,34.728,0,0,0,215.959,153l18.867-94.359a7.742,7.742,0,0,0-1.6-6.418ZM200.78,149.97a19.218,19.218,0,0,1-18.8,15.411H94.839A19.191,19.191,0,0,1,76.01,149.792L59.834,64.859H217.8Z",
    transform: "translate(0 0)",
    fill: "#361f6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M34.2,27a23.2,23.2,0,1,0,23.2,23.2A23.226,23.226,0,0,0,34.2,27Zm0,30.93A7.732,7.732,0,1,1,41.93,50.2,7.74,7.74,0,0,1,34.2,57.93Z",
    transform: "translate(53.853 161.578)",
    fill: "#361f6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M47.2,27a23.2,23.2,0,1,0,23.2,23.2A23.226,23.226,0,0,0,47.2,27Zm0,30.93A7.732,7.732,0,1,1,54.93,50.2,7.735,7.735,0,0,1,47.2,57.93Z",
    transform: "translate(141.374 161.578)",
    fill: "#361f6a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop28);
export default __webpack_public_path__ + "static/media/shop-28.def261bcab72c3d486a078186d411084.svg";
export { ForwardRef as ReactComponent };